import React from 'react';

import {OdontoBooking as OdontoBookingDeprecated} from 'presentation/pages/private/booking/pages';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {OdontoBooking} from 'presentation/modules/booking/odonto/ui/pages/OdontoBooking';

export const MakeOdontoBooking = () => {
	const {isEnabled: showOdontoRefactor} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_REFACTOR_BOOKING_ODONTO,
	);

	if (showOdontoRefactor) {
		return <OdontoBooking />;
	}

	return <OdontoBookingDeprecated />;
};
